/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('backButton', ['$window', '$history',
    function ($window, $history) {
        return {
            restrict: 'A',
            scope: {},
            templateUrl: null,
            link: function (scope) {
                scope.comingFromTrend = function () {
                    return $history.previous().state.name === 'trend';
                };

                scope.back = function() {
                    $history.back();
                };
            }
        };
    }
]);
